<template>
  <div class="main">
    <div class="head">
      <myheadert></myheadert>
      <img src="~@/assets/aboutMe_img/u6086-4.png" class="title">
    </div>
    <div class="middle">
      <div class="location">
        <img src="~@/assets/common_img/house.png">
        <span class="place">您的位置：&nbsp;<span @click="goHome">主页</span>＞外语学习软件</span>
      </div>
      <div class="content">
        <div>
          <p>公司致力于为全球语言学习者开发独一无二的、简便高效的、百分之百符合人类语言自然习得原理的各门类、各语种外语学习软件。
            计划的语种和类别有：儿童英语学习软件（游戏、全球通用）、学生英语学习软件（小学、初中、高中，专门针对中国学生）、
            成人英语学习软件（全球通用）、成人西班牙语学习软件（全球通用）、雅思提分软件（全球）、医学英语学习软件（全球）、医学西班牙语学习软件（全球）。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myheadert from '../header/header_0.vue'
export default {
  name: 'soft',
  components: {
    myheadert
  },
  data () {
    return {

    }
  },
  methods: {
    goHome () {
      this.$router.push(
        {
          path: '/'
        }
      )
      location.reload()
    }
  }
}
</script>

<style scoped>
@media screen and (min-width: 1500px){
  /* 顶部 */
  .head{
    width: 100%;
    height: 253px;
    background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title{
    width: 900px;
    margin-top: 25px;
  }
  /* 位置 */
  .location{
    width: auto;
    height: 27px;
    /* border: 1px red solid; */
    margin-top: 1%;
    margin-left: 14.5%;
    font-size: 18px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img{
    display: inline-block;
  }
  .place{
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 内容 */
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 11pt;
    font-family: '宋体'
  }

}
@media screen and (min-width: 1200px) and (max-width:1499px){
  /* 顶部 */
  .head{
    width: 100%;
    height: 253px;
    background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title{
    width: 750px;
    margin-top: 20px;
  }
  /* 位置 */
  .location{
    width: auto;
    height: 27px;
    /* border: 1px red solid; */
    margin-top: -3%;
    margin-left: 14.5%;
    font-size: 18px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img{
    display: inline-block;
  }
  .place{
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /*  */
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }
}
@media screen and (min-width: 960px) and (max-width:1199px){
  /* 顶部 */
  .head{
    width: 100%;
    height: 253px;
    background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title{
    width: 600px;
    /* margin-left: 20px; */
    margin-top: 10px;
  }
  /* 位置 */
  .location{
    width: auto;
    height: 20px;
    /* border: 1px red solid; */
    margin-top: -6%;
    margin-left: 14.5%;
    font-size: 16px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img{
    width: 3%;
    display: inline-block;
  }
  .place{
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /*  */
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }

}
@media screen and (min-width: 768px) and (max-width:959px){
  /* 顶部 */
  .head{
    width: 100%;
    height: 253px;
    background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title{
    width: 400px;
    /* margin-left: 30px; */
    /* margin-top: 10px; */
  }
  /* 位置 */
  .location{
    width: auto;
    height: 20px;
    /* border: 1px red solid; */
    margin-top: -11%;
    margin-left: 14.5%;
    font-size: 12px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img{
    width: 3%;
    display: inline-block;
  }
  .place{
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }

  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }

}
@media screen and (min-width: 702px) and (max-width:767px){
  /* 顶部 */
  .head{
    width: 100%;
    height: 253px;
    background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title{
    width: 500px;
    margin-left: 50px;
  }
  /* 位置 */
  .location{
    width: auto;
    height: 27px;
    /* border: 1px red solid; */
    margin-top: -12%;
    margin-left: 14.5%;
    font-size: 12px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img{
    width: 3%;
    display: inline-block;
  }
  .place{
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /*  */
  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }

}
@media screen and (max-width:701px){
  .main{
    width: 100%;
  }
  /* 顶部 */
  .head{
    width: 100%;
    height: auto;
    background-image: url('~@/assets/aboutMe_img/gratisography.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .title{
    width: 50%;
    margin-left: 30%;
    margin-top: 10px;
  }
  /* 位置 */
  .location{
    width: auto;
    height: 20px;
    /* border: 1px red solid; */
    margin-top: 10px;
    margin-left: 10%;
    font-size: 12px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img{
    width: 6%;
    display: inline-block;
  }
  .place{
    position: relative;
    left: 1.2%;
    top: -5px;
    cursor: pointer;
  }

  .content {
    width: 70%;
    height: auto;
    margin: 0 auto;
    /* font-size: 16px; */
    position: relative;
    top: 50px;
    padding-bottom: 50px;
  }
  .content p {
    text-indent: 21pt;
    line-height: 26pt
  }
  .content span{
    font-size: 9pt;
    font-family: '宋体'
  }
}
</style>



// WEBPACK FOOTER //
// src/components/soft/soft.vue